import { useTranslation } from 'react-i18next';
import { StyledEmptyStateContainer } from '../JobQuestions.styles';

export const EmptyQuestionsState = () => {
    const { t } = useTranslation();

    return (
        <StyledEmptyStateContainer>
            {t('saveJob.noQuestionsYet')}
        </StyledEmptyStateContainer>
    );
};

